<mat-form-field
    appearance="outline"
    class="entity-table-date-field"
    subscriptSizing="dynamic"
    [class.entity-table-date-field--detail]="context() === EntityTableDateCellContext.DETAIL"
    [class.entity-table-date-field--edited]="edited()">
    @if (errorMessages().length && context() === EntityTableDateCellContext.DETAIL) {
        @for (error of errorMessages(); track error) {
            <mat-error class="text-xs">
                {{ error | transloco }}
            </mat-error>
        }
    }

    <input
        matInput
        [formControl]="control"
        [matDatepicker]="picker"
        [placeholder]="dateFormatPlaceholder"
        (blur)="handleBlur()"
        (dateChange)="onDateChange($event)" />
    <mat-datepicker-toggle
        matIconSuffix
        [for]="picker">
        <mat-icon matDatepickerToggleIcon>calendar_month</mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker #picker />

    @if (errorMessages().length && context() === EntityTableDateCellContext.TABLE) {
        @for (error of errorMessages(); track error) {
            <mat-error class="text-xs">
                {{ error | transloco }}
            </mat-error>
        }
    }
</mat-form-field>
